import { render, staticRenderFns } from "./txt-quarternary.vue?vue&type=template&id=0ae5a112&scoped=true&"
import script from "./txt-quarternary.vue?vue&type=script&lang=js&"
export * from "./txt-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5a112",
  null
  
)

export default component.exports